import { Utils } from '@genial/utils';

export const getFirstBusinessDayOfMonth = (year: number, month: number): Date => {
  const date = new Date(year, month - 1, 1);

  while (Utils.Date.IsWeekend(date)) {
    date.setDate(date.getDate() + 1);
  }

  return date;
};

export const parseMonthYearToReferenceDate = (
  month: string | undefined,
  year: string | undefined
): Date | undefined => {
  if (!month || !year) {
    return undefined;
  }

  const monthNumber = Number(month);
  const yearNumber = Number(year);

  if (
    !Number.isInteger(monthNumber) ||
    monthNumber < 1 ||
    monthNumber > 12 ||
    !Number.isInteger(yearNumber) ||
    yearNumber < 1900
  ) {
    return undefined;
  }

  return getFirstBusinessDayOfMonth(yearNumber, monthNumber);
};

export const getMonthYearFromReferenceDate = (
  referenceDate: Date | undefined
): { month: string; year: string } => {
  if (!referenceDate) {
    return { month: '', year: '' };
  }

  return {
    month: String(referenceDate.getMonth() + 1),
    year: String(referenceDate.getFullYear()),
  };
};

export const PROFITABILITY_MIN_YEAR = 2025;

export const getProfitabilityYearRange = (
  now: Date = new Date()
): { startYear: number; endYear: number } => {
  const endYear = Math.max(PROFITABILITY_MIN_YEAR, now.getFullYear());
  return { startYear: PROFITABILITY_MIN_YEAR, endYear };
};

export const getPreviousMonthReferenceDate = (now: Date = new Date()): Date => {
  const previous = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const year = previous.getFullYear();
  const month = previous.getMonth() + 1;

  if (year < PROFITABILITY_MIN_YEAR) {
    return getFirstBusinessDayOfMonth(PROFITABILITY_MIN_YEAR, 1);
  }

  return getFirstBusinessDayOfMonth(year, month);
};
